var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBracketsSquare(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M120 32H32C14.4 32 0 46.4 0 64V448C0 465.6 14.4 480 32 480H120C133.255 480 144 469.255 144 456V456C144 442.745 133.255 432 120 432H48V80H120C133.255 80 144 69.255 144 56V56C144 42.745 133.255 32 120 32ZM416 32H328C314.745 32 304 42.745 304 56V56C304 69.255 314.745 80 328 80H400V432H328C314.745 432 304 442.745 304 456V456C304 469.255 314.745 480 328 480H416C433.6 480 448 465.6 448 448V64C448 46.4 433.6 32 416 32Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBracketsSquare);
export default __webpack_public_path__ + "static/media/brackets-square.d5ce9bcda684e4951b7ea79bec9caa1d.svg";
export { ForwardRef as ReactComponent };